import React from "react";
import PropTypes from "prop-types";
import DataTable from "react-md/lib/DataTables/DataTable";
import TableHeader from "react-md/lib/DataTables/TableHeader";
import TableBody from "react-md/lib/DataTables/TableBody";
import TableRow from "react-md/lib/DataTables/TableRow";
import TableColumn from "react-md/lib/DataTables/TableColumn";
import { dateToString } from "components/Shared/Formatters";
import { ReadOnlyField } from "components/Shared";

class TimeLogList extends React.Component {

  constructor(props) {
    super(props);

    this.getEfficiency = this.getEfficiency.bind(this);
    this.getEfficiencyClassName = this.getEfficiencyClassName.bind(this);
  }

  getEfficiency() {
    return this.props.appraisalSurveyInfo?.appraiserLogMinutesTotal > 0 ? Number.parseFloat((this.props.appraisalSurveyInfo?.appraiserLogMinutesExpected / this.props.appraisalSurveyInfo?.appraiserLogMinutesTotal) * 100).toFixed(0) : 0;
  }

  getEfficiencyClassName() {
    return this.getEfficiency() < 100 ? "alert-value" : "good-value";
  }

  render() {
    return (
      <div width="100%">
        <div className="time-log-summary">
          <div style={{ float: "left", padding: "10px" }}>
            <ReadOnlyField title="Expected Minutes" fieldValue={this.props.appraisalSurveyInfo?.appraiserLogMinutesExpected} />
          </div>
          <div style={{ float: "left", padding: "10px" }}>
            <ReadOnlyField title="Actual Minutes" fieldValue={this.props.appraisalSurveyInfo?.appraiserLogMinutesTotal} />
          </div>
          <div style={{ float: "left", padding: "10px" }}>
            <ReadOnlyField className={this.getEfficiencyClassName()} title="Efficiency" fieldValue={this.getEfficiency() + "%"} />
          </div>
        </div>
        <div>
          <DataTable plain className="md-data-table__scroll-wrapper" style={{ maxHeight: 600, width: "100%" }}>
            <TableHeader>
              <TableRow>
                <TableColumn style={{ width: 80 }}>Work Date</TableColumn>
                <TableColumn style={{ width: 180 }}>User</TableColumn>
                <TableColumn>Minutes</TableColumn>
              </TableRow>
            </TableHeader>
            <TableBody>
              {this.props.timeLogs
                .sort((a, b) => a.workDate < b.workDate)
                .map(({ id, workDate, userName, timeMinutes }) => (
                  <TableRow key={id}>
                    <TableColumn style={{ verticalAlign: "top", paddingTop: "5px" }}>{dateToString(workDate)}</TableColumn>
                    <TableColumn style={{ verticalAlign: "top", paddingTop: "5px" }}>{userName}</TableColumn>
                    <TableColumn style={{ verticalAlign: "top", paddingTop: "5px" }}>{timeMinutes}</TableColumn>
                  </TableRow>
                ))}
            </TableBody>
          </DataTable>
        </div>
      </div>
    );
  }
}

TimeLogList.propTypes = {
  timeLogs: PropTypes.array,
  appraisalSurveyInfo: PropTypes.object.isRequired
};

export default TimeLogList;